module.exports = __webpack_public_path__ + "img/ad5fab9.png";